export const oldCatalogVersion = '2016-03';
export const currentCatalogVersion = '2026-09';
